export function Toggle({ on, onChange, disabled }: { on: boolean; onChange: (next: boolean) => void; disabled?: boolean }) {
  return (
    <button className="toggle" data-on={on} disabled={disabled} onClick={() => onChange(!on)} type="button" aria-pressed={on}>
      <span className="toggle-knob" />
    </button>
  );
}
